
<script>
import Layout from "@/components/layout/LayoutScreen.vue";

export default {
    
  name: "NotFoundPage",

    components: {
    Layout}
};
</script>


<template>
<Layout>
  <div class="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-light text-dark position-relative">
    <!-- Main Content -->
    <div class="text-center py-5 px-3">
      <!-- Error Code -->
      <h1 class="display-1 font-weight-bold text-primary mb-4">404</h1>

      <!-- Error Message -->
        <p class="h3 font-weight-normal">Oups ! Page introuvable.</p>
        <p class="text-muted mb-4">
        La page que vous recherchez a peut-être été supprimée ou n'existe pas.
        </p>

      <!-- Call to Action Button -->
      <b-button variant="primary" href="/dashboard" class="px-4 py-2 rounded-pill shadow-sm">
        Retour à l'accueil
      </b-button>
    </div>

  </div>
</Layout>

</template>
